import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import API from "@beardeddevops/react.api";

export default class Links extends Framework.Components.View {

	constructor(props) {
	super(props);
	this.loadLink().then();
}

	loadLink = async () => {
		let model = new API.BuildClass(Types.Links._name, API.RequestType.READ);
		this.read = 'GET_ALL';
		model.filter = {'filterUUID': this.props.match.params.id};
		this.data = await model.submit(null, this.read);

		// Try base64 JSON (this is how it encoded sending it to the backend for now)
		try {
			const json = JSON.parse(atob(this.data.data_to_be_set));
			//in the future, depending on what we add, we could just object.keys map through the object and set the localstorage
			if(this.data.pathname === '/dispatch/calendar'){
				localStorage.setItem('users', json['users']);
				localStorage.setItem('regions', json['regions']);
				localStorage.setItem('date', json['date']);
				this.props.history.push(this.data.pathname)
			} else {
				//set the table preference here, and go to that page //this could potentially be bad if malicious users send links to people that shouldn't have them
				localStorage.setItem(this.data.preference, json[this.data.preference]);

				//just go to that pathname
				this.props.history.push(this.data.pathname)
			}

		} catch (err) {
			console.warn("Failed to parse data", err);
		}
	}

	render() {
		return(

			<div className="container-fluid">
				<div style={{flex: 1, justifyContent: "center", justifySelf: "center", fontSize: 32}}>
					Loading your link now, please wait.
				</div>
			</div>


		)
	}
}